__turbopack_context__.v({
  "cls1": "IlluWhy-module__G3a3EW__cls1",
  "cls2": "IlluWhy-module__G3a3EW__cls2",
  "cls3": "IlluWhy-module__G3a3EW__cls3",
  "cls4": "IlluWhy-module__G3a3EW__cls4",
  "cls5": "IlluWhy-module__G3a3EW__cls5",
});
